import BaseLineup from 'services/sports/default/base-lineup';
import Const from 'constants';

export class Lineup extends BaseLineup {
    recalculateLineupsUsedPlayers({incomingValues: {lineups}}) {
        return this.exec('recalculateLineupsUsedPlayers_ShowDown', {lineups});
    }

    sumPlayersProperty({incomingValues: {players, prop}}) {
        let result = 0;
        players.map((player) => {
            result += Number(player.getCapPropValue(prop));
        });

        return result;
    }

    prepareAllNotExcludedPlayersForExposureBox({incomingValues: {players, sportConfig}}) {
        const result = [];
        players.map((sketchyPlayer) => {
            [Const.CAPTAIN_MODE, sketchyPlayer.positionName].map((lineupRole) => {
                const player = cp(sketchyPlayer);

                player.usedLineupsCount = 0;
                player.lineupRole = lineupRole;

                result.push(player);
            });
        });

        return result;
    }

    combineOptimizedAndNotExcludedPlayers({incomingValues: {optimizedPlayers, notExcludedPlayers, sportConfig}}) {
        return this.exec('combineOptimizedAndNotExcludedPlayersByLineupRole', {
            optimizedPlayers,
            notExcludedPlayers,
        });
    }
}
